
  <bxl-edit-exercise (isDirtyChange)="onIsDirtyChange($event)" [exerciseIdInput]="exerciseId" (savedObject)="onExerciseSaved($event)"></bxl-edit-exercise>
